// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23999\" viewBox=\"0 0 24 24\"%3E%3Cpath d=\"M15.707 14.293a8 8 0 1 0-1.414 1.414l5.657 5.657a1 1 0 0 0 1.414-1.414l-5.657-5.657zm-6.707.707a6 6 0 1 1 6-6 6 6 0 0 1-6 6z\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23999%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients-page-container {
  padding: 20px;
  font-family: 'Rubik', sans-serif;
  margin-top: 30px;
}

h1 {
  color: #333;
  margin-bottom: 20px;
  font-size: 32px;
}

.selected-filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-tag {
  background-color: #4caf50;
  color: white;
  padding: 6px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.remove-filter {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}

.filters-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
}

.search-and-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-grow: 1; 
}

.search-bar {
  padding: 10px 15px 10px 40px;
  min-width: 300px; 
  border: 1px solid #d1d5db;
  border-radius: 25px;
  background-color: #f9fafb;
  font-size: 16px;
  color: #333;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: 12px center;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.filter-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-dropdown {
  padding: 10px 15px;
  min-width: 180px; 
  border: 1px solid #d1d5db;
  border-radius: 25px;
  background-color: #f9fafb;
  font-size: 16px;
  color: #333;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: #f9fafb url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 15px center;
  background-size: 25px;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.show-all-button {
  padding: 10px 15px;
  min-width: 150px; 
  border: 1px solid #d1d5db;
  border-radius: 25px;
  background-color: red;
  font-size: 16px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap; 
}

.search-bar:focus {
  border-color: #4caf50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5); 
  outline: none;
}

.filter-dropdown:focus {
  border-color: #4caf50; 
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
  outline: none;
}

.filter-dropdown:hover {
  border-color: #4caf50; 
}

.filters-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.client-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.client-table th {
  background-color: #4caf50;
  color: #ffffff;
  padding: 12px;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
}

.client-table th:hover {
  background-color: #45a049;
  cursor: pointer;
}

.client-table td {
  padding: 12px;
  text-align: center;
  color: #333;
  font-size: 14px;
}

.client-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.client-table tr:nth-child(odd) {
  background-color: #ffffff;
}

.client-table tr:hover {
  background-color: #c5eec7;
  color: #000;
}

.details-button {
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.details-button:hover {
  background-color: #0056b3;
}

.success-message3 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message3 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

.payment-overdue {
  background-color: #ffdddd !important;
  color: #d32f2f;
}

.payment-overdue:hover {
  background-color: #ffcccc !important;
}

.payment-overdue td {
  color: #d32f2f;
  font-weight: 500;
}

.client-table tr.payment-overdue:nth-child(even) {
  background-color: #ffdddd !important;
}

.client-table tr.payment-overdue:nth-child(odd) {
  background-color: #ffdddd !important;
}

.inactive-client {
  opacity: 0.8;
  background-color: #f5f5f5 !important;
}

.inactive-client:hover {
  background-color: #e0e0e0 !important;
}

.inactive-tag {
  background-color: red;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.active-tag {
  background-color: #4caf50;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.client-table tr.inactive-client:nth-child(even) {
  background-color: #f5f5f5 !important;
}

.client-table tr.inactive-client:nth-child(odd) {
  background-color: #f5f5f5 !important;
}

.client-table tr.inactive-client:hover {
  background-color: #e0e0e0 !important;
}

.amount-due {
  background-color: #fff3e0 !important;
  color: #e65100;
}

.amount-due:hover {
  background-color: #ffe0b2 !important;
}

.amount-due td {
  color: #e65100;
  font-weight: 500;
}

.client-table tr.amount-due:nth-child(even),
.client-table tr.amount-due:nth-child(odd) {
  background-color: #fff3e0 !important;
}

.amount-due-even-bg {
  background-color: #fff3e0;
  box-shadow: inset 0 0 0 2px #ffe0b2;
}

.legend-wrapper {
  margin-top: 2rem;
  font-family: 'Inter', sans-serif;
}

.legend-card {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  max-width: 300px;
}

.legend-heading {
  font-size: 0.9rem;
  font-weight: 600;
  color: #555;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
}

.legend-heading::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #f0f0f0;
  border-radius: 4px;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.legend-color {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.08);
  flex-shrink: 0;
}

.payment-overdue-bg {
  background-color: #ffebee;
  box-shadow: inset 0 0 0 2px #ffcdd2;
}`, "",{"version":3,"sources":["webpack://./src/styles/ClientsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,yDAAgR;EAChR,4BAA4B;EAC5B,qBAAqB;EACrB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,uFAAgM;EAChM,qBAAqB;EACrB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC","sourcesContent":[".clients-page-container {\n  padding: 20px;\n  font-family: 'Rubik', sans-serif;\n  margin-top: 30px;\n}\n\nh1 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 32px;\n}\n\n.selected-filters {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filter-tag {\n  background-color: #4caf50;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.remove-filter {\n  margin-left: 8px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.filters-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n}\n\n.search-and-filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-grow: 1; \n}\n\n.search-bar {\n  padding: 10px 15px 10px 40px;\n  min-width: 300px; \n  border: 1px solid #d1d5db;\n  border-radius: 25px;\n  background-color: #f9fafb;\n  font-size: 16px;\n  color: #333;\n  background-image: url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23999\" viewBox=\"0 0 24 24\"%3E%3Cpath d=\"M15.707 14.293a8 8 0 1 0-1.414 1.414l5.657 5.657a1 1 0 0 0 1.414-1.414l-5.657-5.657zm-6.707.707a6 6 0 1 1 6-6 6 6 0 0 1-6 6z\"/%3E%3C/svg%3E');\n  background-repeat: no-repeat;\n  background-size: 18px;\n  background-position: 12px center;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.filter-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.filter-dropdown {\n  padding: 10px 15px;\n  min-width: 180px; \n  border: 1px solid #d1d5db;\n  border-radius: 25px;\n  background-color: #f9fafb;\n  font-size: 16px;\n  color: #333;\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  background: #f9fafb url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\") no-repeat right 15px center;\n  background-size: 25px;\n  cursor: pointer;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.show-all-button {\n  padding: 10px 15px;\n  min-width: 150px; \n  border: 1px solid #d1d5db;\n  border-radius: 25px;\n  background-color: red;\n  font-size: 16px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap; \n}\n\n.search-bar:focus {\n  border-color: #4caf50;\n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5); \n  outline: none;\n}\n\n.filter-dropdown:focus {\n  border-color: #4caf50; \n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n  outline: none;\n}\n\n.filter-dropdown:hover {\n  border-color: #4caf50; \n}\n\n.filters-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.client-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background-color: #ffffff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.client-table th {\n  background-color: #4caf50;\n  color: #ffffff;\n  padding: 12px;\n  text-align: center;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.client-table th:hover {\n  background-color: #45a049;\n  cursor: pointer;\n}\n\n.client-table td {\n  padding: 12px;\n  text-align: center;\n  color: #333;\n  font-size: 14px;\n}\n\n.client-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.client-table tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n.client-table tr:hover {\n  background-color: #c5eec7;\n  color: #000;\n}\n\n.details-button {\n  padding: 8px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.details-button:hover {\n  background-color: #0056b3;\n}\n\n.success-message3 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message3 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n.payment-overdue {\n  background-color: #ffdddd !important;\n  color: #d32f2f;\n}\n\n.payment-overdue:hover {\n  background-color: #ffcccc !important;\n}\n\n.payment-overdue td {\n  color: #d32f2f;\n  font-weight: 500;\n}\n\n.client-table tr.payment-overdue:nth-child(even) {\n  background-color: #ffdddd !important;\n}\n\n.client-table tr.payment-overdue:nth-child(odd) {\n  background-color: #ffdddd !important;\n}\n\n.inactive-client {\n  opacity: 0.8;\n  background-color: #f5f5f5 !important;\n}\n\n.inactive-client:hover {\n  background-color: #e0e0e0 !important;\n}\n\n.inactive-tag {\n  background-color: red;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.active-tag {\n  background-color: #4caf50;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.client-table tr.inactive-client:nth-child(even) {\n  background-color: #f5f5f5 !important;\n}\n\n.client-table tr.inactive-client:nth-child(odd) {\n  background-color: #f5f5f5 !important;\n}\n\n.client-table tr.inactive-client:hover {\n  background-color: #e0e0e0 !important;\n}\n\n.amount-due {\n  background-color: #fff3e0 !important;\n  color: #e65100;\n}\n\n.amount-due:hover {\n  background-color: #ffe0b2 !important;\n}\n\n.amount-due td {\n  color: #e65100;\n  font-weight: 500;\n}\n\n.client-table tr.amount-due:nth-child(even),\n.client-table tr.amount-due:nth-child(odd) {\n  background-color: #fff3e0 !important;\n}\n\n.amount-due-even-bg {\n  background-color: #fff3e0;\n  box-shadow: inset 0 0 0 2px #ffe0b2;\n}\n\n.legend-wrapper {\n  margin-top: 2rem;\n  font-family: 'Inter', sans-serif;\n}\n\n.legend-card {\n  background: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  max-width: 300px;\n}\n\n.legend-heading {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 5px;\n}\n\n.legend-heading::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background: #f0f0f0;\n  border-radius: 4px;\n}\n\n.legend-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.legend-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.legend-color {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 1px solid rgba(0,0,0,0.08);\n  flex-shrink: 0;\n}\n\n.payment-overdue-bg {\n  background-color: #ffebee;\n  box-shadow: inset 0 0 0 2px #ffcdd2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
